import * as React from 'react'

import { Box, Button, Table } from '@factorialco/deprecated-design-system'

import { ReconciliationItem } from 'modules/banking/hooks/useReconciliationForm'

import { SummaryDateCell } from './SummaryDateCell'
import { SummaryDescriptionCell } from './SummaryDescriptionCell'
import { SummaryMoneyCell } from './SummaryMoneyCell'

type ReconciliationProps = {
  reconciliations: ReconciliationItem[]
  onRemove: (item: ReconciliationItem) => void
}

export const Reconciliations: React.FC<ReconciliationProps> = ({ reconciliations, onRemove }) => {
  return (
    <>
      {reconciliations.map((reconciliation) => (
        <Table.Row key={reconciliation.id}>
          <SummaryDateCell date={reconciliation.date} />
          <SummaryDescriptionCell
            description={reconciliation.description}
            secondaryDescription={reconciliation.secondaryDescription}
          />
          <SummaryMoneyCell
            visible={reconciliation.type == 'debit'}
            amount={reconciliation.amountCentsToReconcile}
            currency={reconciliation.currency}
            locale={reconciliation.locale}
          />
          <SummaryMoneyCell
            visible={reconciliation.type == 'credit'}
            amount={reconciliation.amountCentsToReconcile}
            currency={reconciliation.currency}
            locale={reconciliation.locale}
          />
          <Table.Cell noBorder paddingX="s0" paddingY="s4">
            <Box paddingLeft="s12">
              <Button type="secondary" iconName="delete" onClick={() => onRemove(reconciliation)} />
            </Box>
          </Table.Cell>
        </Table.Row>
      ))}
    </>
  )
}
